"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UAComponent = void 0;

const base_1 = require("./base");

class UAComponent extends base_1.CustomComponent {
  getValue() {
    let value = '';

    if (typeof navigator !== 'undefined' && (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent)) {
      value = navigator.userAgent;
    }

    return value;
  }

}

exports.UAComponent = UAComponent;